export default Object.freeze({
  New: 1,
  Renewal: 2,
  Complaint: 3,
  Conversion: 4,
});
